import { useState } from 'react'
import CustomTable from '../Custom/Table'
import useRegistroTable from './useRegistroTable'
import ParticipanteModal, { ParticipanteI } from './ParticipanteModal'

interface Props {
    participantes: ParticipanteI[]
}

const RegistroTable = ({ participantes }: Props) => {

    const { columns } = useRegistroTable()
    const [selected, setSelected] = useState<ParticipanteI | null>(null)

    const columnsWithAction = [
        ...columns,
        {
            field: '_action',
            headerName: '',
            width: 10,
            sortable: false,
            renderCell: () => null
        }
    ]

    return (
        <>
            <CustomTable
                rows={participantes}
                columns={columnsWithAction}
                onRowClick={(params: any) => setSelected(params.row)}
                getRowClassName={(params: any) => params.row.fechaAsistencia ? 'row-confirmado' : ''}
                sx={{ '& .row-confirmado': { backgroundColor: '#e3f2fd' }, '& .row-confirmado:hover': { backgroundColor: '#bbdefb' } }}
            />
            <ParticipanteModal
                participante={selected}
                onClose={() => setSelected(null)}
            />
        </>
    )
}

export default RegistroTable
